import ConditionBlock, { ConditionProps } from 'components/UI/Blocks/ConditionBlock'
import Typography from 'components/UI/Typography'
import { Fragment, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import tw, { TwStyle } from 'twin.macro'
import { conditionBlockStyles } from 'utils/constants'

type LoanConditionsProps = {
  conditions?: Array<ConditionProps>
  children?: ReactNode
  header?: ReactNode
  isConditionsChangeable?: boolean
  onConditionChangeClick?: () => void
  twStyle?: TwStyle
  conditionsStyle?: TwStyle
}

const LoanConditions = ({
  conditions,
  children,
  header,
  isConditionsChangeable,
  twStyle,
  conditionsStyle,
  onConditionChangeClick
}: LoanConditionsProps) => {
  //tools
  const { t } = useTranslation()

  return (
    <div css={[tw`rounded-none md:rounded-2xl bg-secondary overflow-hidden`, twStyle]}>
      <Fragment>{header}</Fragment>
      <div css={[tw`grid grid-cols-2 border-t border-b border-stroke`, conditionsStyle]}>
        {conditions
          ? conditions.map((condition, idx) => (
              <ConditionBlock
                twStyle={conditionBlockStyles}
                key={`condition_${idx}`}
                body={condition.body}
                caption={condition.caption}
                footer={condition.footer}
                icon={condition.icon}
              />
            ))
          : null}
      </div>
      {children}
      {isConditionsChangeable ? (
        <Typography
          variant='subbody'
          weight='bold'
          twStyle={tw`py-3 px-5 text-primary-middle cursor-pointer`}
          onClick={onConditionChangeClick}
        >
          {t('flow-change-condition')}
        </Typography>
      ) : null}
    </div>
  )
}

export default LoanConditions
